const learnerEventsToggle = () => {
  const toggles = document.querySelectorAll('.js-learner-events-toggle');

  const handleClick = (event) => {
    const header = event.currentTarget;
    const body = header.nextElementSibling;
    const chevron = header.querySelector('.chevron');

    if (body) {
      body.classList.toggle('hidden');
    }
    header.classList.toggle('is-open');
    if (chevron) {
      chevron.classList.toggle('is-open');
    }
  };

  toggles.forEach(toggle => toggle.addEventListener('click', handleClick));

  return () => {
    toggles.forEach(toggle => toggle.removeEventListener('click', handleClick));
  };
};

export default learnerEventsToggle;
